import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBKAwzdZR_VWMozOlkKXqP6EACPfiwnVUk',
  authDomain: 'wilasineefolio.firebaseapp.com',
  projectId: 'wilasineefolio',
  storageBucket: 'wilasineefolio.firebasestorage.app',
  messagingSenderId: '621744371712',
  appId: '1:621744371712:web:0251b4b809ec3decaf40e5',
  measurementId: 'G-FEP6M5F7SL',
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics, logEvent };
